import { SvgProps } from "../../../types";

const RuleBuilderSvg = (props: SvgProps) => (
  <svg
    width={props.width ?? 20}
    height={props.height ?? 20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M1.81818 19.0909C1.31818 19.0909 0.890152 18.9129 0.534091 18.5568C0.17803 18.2008 0 17.7727 0 17.2727V7.27273H1.81818V17.2727H17.2727V19.0909H1.81818ZM5.45455 15.4545C4.95455 15.4545 4.52652 15.2765 4.17045 14.9205C3.81439 14.5644 3.63636 14.1364 3.63636 13.6364V3.63636H8.18182V1.81818C8.18182 1.31818 8.35985 0.890152 8.71591 0.534091C9.07197 0.17803 9.5 0 10 0H13.6364C14.1364 0 14.5644 0.17803 14.9205 0.534091C15.2765 0.890152 15.4545 1.31818 15.4545 1.81818V3.63636H20V13.6364C20 14.1364 19.822 14.5644 19.4659 14.9205C19.1098 15.2765 18.6818 15.4545 18.1818 15.4545H5.45455ZM5.45455 13.6364H18.1818V5.45455H5.45455V13.6364ZM10 3.63636H13.6364V1.81818H10V3.63636Z"
      fill={props.fill ?? "#1F1F1F"}
    />
  </svg>
);
export default RuleBuilderSvg;
